export default __webpack_public_path__ + "static/media/phone.944f0ca6.svg";